module.exports = __webpack_public_path__ + "img/home_image_banner@2x.58d676c3.png";